import { render } from "./NavPlantSystemJournalsSidebar.vue?vue&type=template&id=5e381e9c"
import script from "./NavPlantSystemJournalsSidebar.vue?vue&type=script&lang=js"
export * from "./NavPlantSystemJournalsSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__